export const constructListingImageUrl = (filename) => {
    const baseUrl = 'https://s3-us-west-1.amazonaws.com/securspace-files/listing-images/';
    return baseUrl + encodeURIComponent(filename)
}
export const constructGalleryImageUrl = (filename) => {
    const baseUrl = 'https://s3-us-west-1.amazonaws.com/securspace-files/gallery/';
    return baseUrl + encodeURIComponent(filename)
}
